import { CollectionEntity } from "@busy-human/gearbox";
import { ChecklistDefinitions } from "../ChecklistDefinitions/index.js";
export var AssignedChecklistItem;
(function (AssignedChecklistItem) {
    function Default() {
        return {
            name: '',
            description: '',
            completionMethod: 'user-checks-off',
            category: ChecklistDefinitions.ChecklistCategory.other,
            dueDateType: 'absolute',
            dueDateAbsolute: '',
            status: 'not-started',
            resolvedAbsoluteDueDate: '',
            builderId: ''
        };
    }
    AssignedChecklistItem.Default = Default;
    class CollectionClass extends CollectionEntity {
        relationships = {};
        defaults() {
            return Default();
        }
    }
    AssignedChecklistItem.CollectionClass = CollectionClass;
    AssignedChecklistItem.Collection = new CollectionClass({ path: '/AssignedChecklistItems' });
})(AssignedChecklistItem || (AssignedChecklistItem = {}));
//# sourceMappingURL=index.js.map